import { createFirestoreApi } from '#firebase/firestoreApi'

import { profileSchema } from './schemas'

const api = createFirestoreApi({
  authenticated: true,
  name: 'profiles',
  schema: profileSchema,
})

export const {
  useShowQuery: useShowProfileQuery,
  getShowQueryOptions: getShowProfileQueryOptions,
  useUpsertMutation: useUpsertProfileMutation,
} = api
